export default __webpack_public_path__ + "static/media/book.c433949a.gif";